import { createFileRoute } from "@tanstack/react-router";
import { ToolEditPage } from "@client/components/tool-workshop/tool-edit-page";

export const Route = createFileRoute("/_app/bots/tools/new")({
  component: ToolEditPage,
});
